import React from 'react';
import PropTypes from 'prop-types';
import MUTypography from '../../../../../ui/MUTypography';

const Info4 = (props) => (
  <div>
    <MUTypography variant="h4" className={props.classes.h4} gutterBottom>
      API Overview
    </MUTypography>

    <MUTypography variant="display1" className={props.classes.paragraph} paragraph>
      <strong>Welcome to the Albaraka API Developer Portal!</strong><br/><br/>
      Embark on a seamless journey into the realm of possibilities with Albaraka APIs. Our Developer Portal empowers you to craft innovative applications that leverage the robust capabilities of Albaraka's cutting-edge technology. Whether you're a seasoned developer or just starting your coding adventure, we've curated a comprehensive set of resources to ensure your success.<br/><br/>
      Unleash the potential of Albaraka APIs by creating your first application. We've equipped you with everything you need to kickstart your development journey. To make the most of your experience, we highly recommend exploring the detailed guide below, covering crucial aspects such as Getting Started, Authorization, API Usage and Postman Usage.
    </MUTypography>

    <MUTypography variant="h5" className={props.classes.h5} gutterBottom>
      <strong>Why Choose Albaraka APIs for Your Application?</strong>
    </MUTypography>

    <MUTypography variant="display1" className={props.classes.paragraph} paragraph>
      ✓ <strong>Dynamic API Management:</strong> Adjust your API selections at any time to meet the evolving needs of your application in the sandbox environment.<br/>
      ✓ <strong>Effortless Integration:</strong> Seamless integration with Albaraka APIs ensures a smooth and efficient development process.<br/>
      ✓ <strong>Comprehensive API Access:</strong> Access the full spectrum of our APIs without any cost. We believe in providing developers with unrestricted access to explore, innovate, and create without financial constraints.<br/>
      ✓ <strong>Diverse Support Channels:</strong> Benefit from our exceptional support system, including traditional help tickets and innovative solutions like Slack.
    </MUTypography>

    <MUTypography variant="display1" className={props.classes.paragraph} paragraph>
      Create, innovate, and elevate your application with Albaraka APIs.
    </MUTypography>
  </div>
);

Info4.propTypes = {
  classes: PropTypes.object.isRequired
};

export default Info4;
